import * as React  from "react";
import { useState, useEffect} from "react";
import axios from "axios";
// import Alert from '../commons/alert'
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import {getCsrfToken} from '../../commons/authenticityToken';

const PER_PAGE = 20;

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
  // 店舗情報
  const [institutions, setInstitutions] = useState([]);
  // 決済情報
  const [paymentInstitutions, setPaymentInstitutions] = useState([]);

  //削除時の企業情報
  const [deleteInstitution, setDeleteInstitution] = useState({id: 0, institution_name: ""});

  // 検索内容
  const [searchName, setSearchName] = useState("");

  // ページネーション
  const [startCount, setStartCount] = useState(0);
  const [endCount, setEndCount] = useState(startCount + PER_PAGE);
  const [currentPage, setCurrentPage] = useState(0);

  // メッセージ系
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(true);

  // 初期ロード
  useEffect(() =>{
    searchInstitutions();
  }, []);

  // 開始位置がかわったとき
  useEffect(() =>{
    setEndCount(startCount + PER_PAGE);
  }, [startCount])

  // 削除モーダル
  useEffect(() =>{
    if (deleteInstitution.id != 0){
      document.getElementById("open_delete_modal").click();
    }
  }, [deleteInstitution])

  const onChangePage = (value) => {
    setStartCount(value['selected'] * PER_PAGE);
    setCurrentPage(value['selected'])
  }

  function initStates() {
    setIsLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    setStartCount(0);
    setCurrentPage(0);
  }

  // 検索
  function searchInstitutions() {
    initStates();
    axios.get(
      '/api/internal/institutions/search_institutions', { params: { name: searchName }})
      .then(function (response) {
        setInstitutions(response.data.m_institutions);
        setPaymentInstitutions(response.data.payment_accounts);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
    }).finally(() => {
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      setIsLoading(false);
    });
  }

  function deleteSubmit(){
    initStates();
    axios.delete(
      '/api/internal/institutions/destroy', { data: { id: deleteInstitution.id }})
      .then(function (response) {
        setInstitutions(
          institutions.filter(function(institution){
            return institution.id !== deleteInstitution.id
        }));
        setSuccessMessage(response.data.message);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);

      }).finally(() => {
        setDeleteInstitution({id: 0, institution_name: ""})
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
        setIsLoading(false);
      });
    
  }

  return (
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { successMessage &&
        <div className="alert fade in alert-success ">
          <button type="button" className="close" data-dismiss="alert">×</button>
          {successMessage}
        </div>
      }
      <h3>店舗一覧</h3>
      <br/>

      {/* 検索エリア */}
      <div id="patient_search_area" className="panel panel-success">
        <div className="panel-heading">検索エリア</div>
          <div className="panel-body">
            <div className="row">
              <div className="form-group col-md-7 col-xs-12">
                <label >企業名・事業所名・店舗コード</label>
                <input 
                  type="text"
                  name="search_name" 
                  id="search_name" 
                  className="form-control col-lg-1" 
                  placeholder="検索したい内容を入力してください"
                  onChange={(e) => setSearchName(e.target.value)}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-offset-10 col-md-2 col-xs-12 text-right">
                <input type="submit" name="button_search" value="検索" className="btn btn-lg btn-primary" data-disable-with="検索" onClick={() => searchInstitutions()}/>
              </div>
            </div>
        </div> 
      </div>

      {/* CSV取り込みボタン */}
      <div className="actions text-right">
        <button disabled={props.is_gcs_reader} className="btn btn-primary" onClick={ ()=> location.href=`/institutions/csv_import`}>CSV取り込み</button>
      </div>

      {/* 表示エリア */}
      <div className="table-responsive">
        <table id="notice_table" className="table table-bordered">
          <thead>
          <tr className="success">
              <th scope="col" className="text-center va_middle col-md-1">id</th>
              <th scope="col" className="text-center va_middle col-md-2">店舗コード</th>
              <th scope="col" className="text-center va_middle col-md-3">企業名</th>
              <th scope="col" className="text-center va_middle col-md-3">事業所名</th>
              <th scope="col" className="text-center va_middle col-md-1">ご利用<br/>システム</th>
              <th scope="col" colSpan={3}  className="text-center col-md-2"/>
          </tr>
          </thead>
          <tbody>
            { institutions.slice(startCount, endCount).map((institution) =>　{ 
              return(
                <tr>
                  <td className="text-center va_middle">{institution.id}</td>
                  <td className="va_middle">{institution.gcs_institution_code}</td>
                  <td className="va_middle">{institution.company_name}</td>
                  <td className="va_middle">{institution.institution_name}</td>
                  <td className="va_middle">
                    { institution.videocall_enable_flg === 1 && <span className="label videocall-bgcolor">Videocall</span> }
                    { institution.interview_enable_flg === 1 && <span className="label interview-bgcolor">先確認</span> }
                    { paymentInstitutions.includes(institution.gcs_institution_code) && <span className="label followcarepaymet-bgcolor">オンライン決済</span> }
                  </td>
                  
                  <td className="va_middle">
                    <button className="btn btn-success" onClick={ ()=> location.href=`/users/${institution.id}/index`}>ユーザー編集</button>
                  </td>
                  <td className="va_middle">
                    <button className="btn btn-primary" onClick={ ()=> location.href=`/institutions/${institution.id}/edit`}>編集</button>
                  </td>
                  <td className="va_middle">
                    {!props.is_gcs_reader && <input id="open_delete_modal" type="hidden" data-toggle="modal" data-target="#institution_delete_modal"/>}
                    <button disabled={props.is_gcs_reader} className="btn btn-danger" onClick={ () => setDeleteInstitution(institution)}>削除</button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* 削除確認モーダル */}
      <div className="modal fade" data-backdrop="static" id="institution_delete_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>削除します</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
          以下の店舗情報を削除します。<br />
          よろしいですか？<br />
          【{deleteInstitution && deleteInstitution.institution_name}】<br/>
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: 'red', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={() => deleteSubmit() }
          >
          削除する
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal" onClick={ () => setDeleteInstitution({id: 0, institution_name: ""})}>キャンセル</button>
        </div>
        </div>
      </div>

      <div className="text-center">
        <ReactPaginate
          pageCount={Math.ceil(institutions.length / PER_PAGE)} 
          marginPagesDisplayed={1}
          pageRangeDisplayed={5} 
          onPageChange={onChangePage} 
          containerClassName='pagination'
          pageClassName='page-item'
          pageLinkClassName='page-link'
          activeClassName='active'
          previousLabel='前'
          nextLabel='次'
          previousClassName='page-item'
          nextClassName='page-item'
          previousLinkClassName='page-link'
          nextLinkClassName='page-link'
          disabledClassName='disabled'
          breakLabel='...' 
          breakClassName='page-item'
          breakLinkClassName='page-link'
          forcePage={currentPage}
        />
      </div>

      <div className="actions mt40 text-center va_middle">
        <button disabled={props.is_gcs_reader} className="btn btn-primary" onClick={ ()=> location.href=`/institutions/new`}>店舗登録</button>
      </div>


    </LoadingOverlay>
  )
}

export default Index
